import React from "react"

import CheckIcon from "@modules/common/components/icons/selected-check"

interface InstallmentOptionProps {
  uuid: string
  title: string
  subtitle: string
  tabInstallmentLabel: string
  isSelected: boolean
  onSelect: (uuid: string) => void
}

const InstallmentOption: React.FC<InstallmentOptionProps> = ({ uuid, title, subtitle, tabInstallmentLabel, isSelected, onSelect }) => {
  return (
    <div
      className={`relative flex cursor-pointer items-center rounded-xl bg-white p-3 shadow-sm sm:p-4 ${isSelected ? "border-2 border-nelo-blue" : "border border-gray-300"} transition-colors duration-300 hover:bg-nelo-sky-50`}
      onClick={() => onSelect(uuid)}
    >
      <div
        className={`mr-3 flex h-5 w-5 items-center justify-center rounded-md border-2 sm:mr-4 sm:h-6 sm:w-6 ${
          isSelected ? "border-nelo-blue bg-nelo-sky-200" : "border-gray-300"
        }`}
      >
        {isSelected && <CheckIcon />}
      </div>
      <div className="grow">
        <h3 className="font-nunito text-base font-bold text-nelo-blue sm:text-lg">{title}</h3>
        <p className="font-nunito text-xs text-ui-fg-base sm:text-sm">{subtitle}</p>
      </div>
      <div className="absolute right-0 top-0 rounded-bl-lg rounded-tr-lg bg-nelo-blue px-2 py-1 font-nunito text-xs text-white">
        {tabInstallmentLabel}
      </div>
    </div>
  )
}

export default InstallmentOption
